<template>
  <div class="sample-detail-secondary-results">
    <div class="input-row">
      <SampleDetailParticleControl
        label="Water (%)"
        propName="waterPercent"
        propAverageName="averageWaterPercent"
        propSeverityName="waterSeverityID"
        :tabindex="245"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="true"
        :mappings="mappings"
        :removeLabelClass="true"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="ISO Class Code"
        propName="isoClassCode"
        :tabindex="269"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :includeAverage="false"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Water (ppm)"
        propName="waterPpm"
        propAverageName="averageWaterPpm"
        propSeverityName="waterSeverityID"
        :tabindex="246"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="true"
        :mappings="mappings"
        :removeLabelClass="true"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="4 Micron"
        propName="particleCount4"
        propAverageName="averageParticleCount4"
        :tabindex="270"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Oxidation (D7414)"
        propName="newOxidation"
        propAverageName="averageNewOxidation"
        :tabindex="247"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="6 Micron"
        propName="particleCount6"
        propAverageName="averageParticleCount6"
        :tabindex="271"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Nitration (D7624)"
        propName="newNitration"
        propAverageName="averageNewNitration"
        :tabindex="248"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="10 Micron"
        propName="particleCount10"
        propAverageName="averageParticleCount10"
        :tabindex="272"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Sulfation (D7415)"
        propName="newSulfation"
        propAverageName="averageNewSulfation"
        :tabindex="249"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="14 Micron"
        propName="particleCount14"
        propAverageName="averageParticleCount14"
        :tabindex="273"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        propName="sootIndex"
        propAverageName="averageSootIndex"
        :tabindex="250"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="true"
      />
      <SampleDetailParticleControl
        label="25 Micron"
        propName="particleCount25"
        propAverageName="averageParticleCount25"
        propSeverityName="particleCount25To50SeverityID"
        :tabindex="274"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Viscosity 100c"
        propName="viscosity100c"
        propAverageName="averageViscosity100C"
        propSeverityName="viscosity100CSeverityID"
        :tabindex="251"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="1"
        :roundDecimals="false"
      />
      <SampleDetailParticleControl
        label="50 Micron"
        propName="particleCount50"
        propAverageName="averageParticleCount50"
        :tabindex="275"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Viscosity 40c"
        propName="viscosity40c"
        propAverageName="averageViscosity40C"
        propSeverityName="viscosity40CSeverityID"
        :tabindex="252"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="1"
        :roundDecimals="false"
      />
      <SampleDetailParticleControl
        label="100 Micron"
        propName="particleCount100"
        propAverageName="averageParticleCount100"
        :tabindex="276"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        propName="fuelDilution"
        propAverageName="averageFuelDilution"
        :tabindex="253"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="1"
        :roundDecimals="false"
      />
      <SampleDetailParticleControl
        label="Sulfur"
        propName="sulphur"
        propAverageName="averageSulphur"
        :tabindex="277"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        propName="antifreeze"
        propAverageName="averageAntifreeze"
        :tabindex="254"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        propName="chlorine"
        propAverageName="averageChlorine"
        :tabindex="278"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="0"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="BN (D4739)"
        propName="tbn"
        propAverageName="averageTbn"
        :tabindex="255"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="false"
      />
      <SampleDetailParticleControl
        label="MPC"
        propName="mpc"
        propAverageName="averageMPC"
        :tabindex="279"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="1"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="BN (D2896)"
        propName="bn"
        propAverageName="averageBn"
        :tabindex="256"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="false"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="AN (D664)"
        propName="tan"
        propAverageName="averageTan"
        :tabindex="257"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :mappings="mappings"
        :decimalPlaces="2"
        :roundDecimals="false"
      />
    </div>
  </div>
</template>

<script>
import SampleDetailParticleControl from './OilSampleResultParticleControl.vue';

export default {
  name: 'SampleDetailSecondaryResults',
  props: {
    sampleData: {
      type: Object,
      default() {
        return {};
      }
    },
    showAverageResults: {
      type: Boolean
    },
    mappings: {
      type: Object,
      required: true
    }
  },
  components: {
    SampleDetailParticleControl
  }
};
</script>

<style lang="scss" scoped>
.sample-detail-secondary-results {
  padding: 10px;

  .input-row {
    display: flex;
    flex-flow: row wrap;
    flex-wrap: nowrap;
    width: 100%;
  }
}

:deep(.autocomplete-text) {
  margin-right: 0;
}
</style>
